import { Collapse } from "antd";
import React from "react";
import { ICollapseProps } from "./interface";
import { EColors } from "../ZColors/interface";

import "./index.less";

const ZCollapse: React.FC<ICollapseProps> = props => {
	const {
		panels,
		headerBackgroundColor = EColors.GRAY,
		headerBackgroundColorVariant = 1,
		...collapseProps
	} = props;

	return (
		<Collapse {...collapseProps}>
			{props.panels.map(panel => {
				const { render, className, key, ...rest } = panel;
				return (
					<Collapse.Panel
						{...rest}
						key={key}
						className={`z-collapse-panel bg-${headerBackgroundColor}-${headerBackgroundColorVariant} ${
							className ?? ""
						}`}
					>
						{render}
					</Collapse.Panel>
				);
			})}
		</Collapse>
	);
};

export default ZCollapse;
